import React, { useState, useEffect, useRef } from 'react';
// import './Management2.css';
import { FaEdit, FaPlus, FaTrash } from 'react-icons/fa';
import axios from 'axios';
import { FaSave } from 'react-icons/fa';
import * as XLSX from 'xlsx';
const Grocerybasicmenu  = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [addedItems, setAddedItems] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [dishId, setDishId] = useState(null);
  const [showImageInput, setShowImageInput] = useState(false);
  const [dishList, setDishList] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [image, setImage] = useState(null);
  const [text, setText] = useState('');
  const [isOn, setIsOn] = useState(false);
  const [filteredDishes, setFilteredDishes] = useState([]);
  const [isVegSelected, setIsVegSelected] = useState(null);
  const [dishes, setDishes] = useState([]);
  const [isNonVegSelected, setIsNonVegSelected] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  // state
  const [chefType, setChefType] = useState("Chef_South");
  const [acceptedTerms, setAcceptedTerms] = useState(false);


  const handleFilterClick = (tag) => {
    const vegSelected = tag === 'Veg';
    setIsVegSelected(vegSelected);
    applyFilter(data, vegSelected); // apply on existing data
  };
  const handleSearchChange = (value) => {
    setSearchTerm(value.toLowerCase());

    const filtered = data.map(category => {
      const filteredSubcategories = category.subcategories.filter(sub =>
        sub.subName.toLowerCase().includes(value.toLowerCase())
      );

      const isCategoryMatch = category.category.toLowerCase().includes(value.toLowerCase());

      if (isCategoryMatch || filteredSubcategories.length > 0) {
        return {
          ...category,
          subcategories: isCategoryMatch ? category.subcategories : filteredSubcategories
        };
      }

      return null;
    }).filter(Boolean); // remove null values

    setFilteredData(filtered);
  };









  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);
  const [selectedChefTypes, setSelectedChefTypes] = useState([]);


  const [showSubcategoryPopup, setShowSubcategoryPopup] = useState(false);
  const [selectedParentDish, setSelectedParentDish] = useState(null);

  const [subDishName, setSubDishName] = useState('');
  const [subDishImage, setSubDishImage] = useState('');
  const [price, setPrice] = useState('');
  const [description, setDescription] = useState('');
  const [stockQuantity, setStockQuantity] = useState('');
  const [gst, setGst] = useState('');

  const [discount, setdiscount] = useState('');
  const [packingCharges, setPackingCharges] = useState('');
  const [tag, setTag] = useState('Veg');
  const [stock, setStock] = useState('In Stock');
  const [menuStatus, setMenuStatus] = useState(true);
  const [parentDishDetails, setParentDishDetails] = useState(null);
  // const [isVegSelected, setIsVegSelected] = useState(true); // true = Veg, false = Non-Veg
  // const [data, setData] = useState([]); // Full data
  const [filteredData, setFilteredData] = useState([]); // Filtered by tag
  // const [image, setImage] = useState('');
  const [showSubEditModal, setShowSubEditModal] = React.useState(false);
  const [editSubItem, setEditSubItem] = React.useState({
    dishId: '',
    subName: '',
    price: '',
    stockQuantity: '',
    gst: '',
    packingCharges: '',
    image: '',
    chefType: '',
    parentIndex: null,
    subIndex: null,
  });
  const applyFilter = (allData, vegOnly) => {
    if (vegOnly === null) {
      setFilteredData(allData); // No filter, show all
      return;
    }

    const filtered = allData.map(category => {
      const filteredSubcategories = category.subcategories.filter(
        sub => vegOnly ? sub.tag === "Veg" : sub.tag === "Non_Veg"
      );

      return {
        ...category,
        subcategories: filteredSubcategories
      };
    }).filter(cat => cat.subcategories.length > 0); // only show categories with subcategories

    setFilteredData(filtered);
  };





  const [subCategoryData, setSubCategoryData] = React.useState({
    dishImage: '',
    // other fields: subDishName, price, tag, stock, menuStatus ...
  });
  // and when opening popup:
  // Top of your component file
  const CHEF_TYPES = [
    "Chef_All",
    "Chef_North",
    "Chef_South",
    "Chef_Chinese",
    "Chef_Continental",
  ];
  const handleChefTypeChange = (value) => {
    setChefType((prev) =>
      prev.includes(value)
        ? prev.filter((v) => v !== value)
        : [...prev, value]
    );
  };


  const handleEditSubcategory = async (subDishId, subIndex, parentIndex) => {
    try {
      // Optional: Set current dishId
      setDishId(subDishId);

      const token = localStorage.getItem("authToken");

      const response = await axios.get(
        `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/grocery/dishes/${subDishId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const subDish = response.data;

      console.log('Fetched Subcategory Dish:', subDish);

      setEditSubItem({
        dishId: subDish.dishId,
        subName: subDish.dishName || '',
        price: subDish.price || '',
        stockQuantity: subDish.stockQuantity || '',
        gst: subDish.gst || '',
        packingCharges: subDish.packingCharges || '',
        image: subDish.dishImage || '',
        chefType: subDish.chefType || '',
        parentIndex,
        subIndex,
      });

      setShowSubEditModal(true);
    } catch (error) {
      alert('Error fetching subcategory details:\n' + (error.response?.data?.message || error.message));
      console.error(error);
    }
  };

  const submitEditSubcategory = async () => {
    if (!editSubItem || !editSubItem.dishId) {
      alert("Subcategory Dish ID is missing!");
      return;
    }

    try {
      const token = localStorage.getItem("authToken"); // 🔐 Get token from localStorage

      if (!token) {
        alert("Authentication token not found!");
        return;
      }

      const url = `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/dishes/${editSubItem.dishId}`;

      const payload = {
        dishName: editSubItem.subName,
        price: editSubItem.price,
        image: editSubItem.image,
        stockQuantity: editSubItem.stockQuantity,
        gst: editSubItem.gst,
        packingCharges: editSubItem.packingCharges,
      };

      const response = await axios.put(url, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}` // ✅ Include token in header
        },
      });

      alert('Subcategory updated successfully!');
      window.location.reload(); // or refresh data instead
    } catch (error) {
      alert("Failed to update subcategory");
      console.error(error);
    }
  };




  const handleAddSubCategory = async (dishId) => {
    // alert(`Selected dishId: ${dishId}`);

    const url = `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/grocery/dishes/${dishId}`;
    // console.log('Request URL:', url);

    const token = localStorage.getItem("authToken"); // ✅ Get token from localStorage
    if (!token) {
      alert("Authentication token missing. Please log in again.");
      return;
    }

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`, // ✅ Include token in headers
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const dishData = await response.json();
      // console.log("Fetched dish data:", dishData);

      // Set dish data to state for popup
      setParentDishDetails(dishData);
      setShowSubcategoryPopup(true);

    } catch (error) {
      console.error("Failed to fetch dish data:", error);
    }
  };




  const handleSubImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result; // Includes data:image/... prefix
      setSubCategoryData(prev => ({
        ...prev,
        dishImage: base64String
      }));
      setImage(base64String); // Also sets preview
    };
    reader.readAsDataURL(file);
  };




  const handleSubcategorySubmit = async () => {
    if (!subDishName.trim() || !price.trim()) {
      alert("Please fill in all required fields.");
      return;
    }

    const cleanImage = (subCategoryData?.dishImage || "").replace(/^data:image\/\w+;base64,/, '');
    const vendorId = localStorage.getItem("vendorId");
    if (!vendorId) {
      alert("Vendor ID not found. Please log in again.");
      return;
    }

    const token = localStorage.getItem("authToken");
    if (!token) {
      alert("Authentication token missing. Please log in again.");
      return;
    }

    const payload = {
      dishId: 0,
      parentId: Number(parentDishDetails?.dishId) || 1,
      dishName: subDishName.trim(),
      price: parseFloat(price),
      tag: tag || "Veg",
      stock: stock ? "In_Stock" : "Out_of_Stock",
      chefType: chefType || "Chef_South",
      menuStatus: menuStatus ? "Enable" : "Disable",
      dishImage: cleanImage || "",
      description: description.trim(), // make sure state is correct
      stockQuantity: stockQuantity || 0,
      discount: discount || 0,
      gst: gst || 0,
      packingCharges: packingCharges || 0,
      consumedQuantity: 0,
      balanceQuantity: 0,
      effectivePrice: 0,
    };

    // ✅ Show payload in alert to debug
    // alert("Payload to send:\n" + JSON.stringify(payload, null, 2));

    try {
      const res = await axios.post(
        `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/dishes?vendorId${vendorId}`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );

      const savedDish = res.data;
      // alert("Subcategory added successfully!\n\nSaved Data:\n" + JSON.stringify(savedDish, null, 2));

      // Reset form
      setSubDishName('');
      setDescription(''); // ✅ make sure this matches your state
      setPrice('');
      setStockQuantity('');
      setGst('');
      setPackingCharges('');
      setTag('Veg');
      setStock('In Stock');
      setMenuStatus(true);
      setSubCategoryData({ dishImage: '' });
      setdiscount('');
      fetchData();
    } catch (error) {
      console.error("Error response:", error);

      // Get a meaningful message
      const message =
        error.response?.data?.error ||      // API provided error
        error.response?.data?.message ||    // sometimes API uses 'message'
        error.message ||                     // Axios error message
        "Unknown error";

      // alert("Save failed!\n" + message);
    }

  };









  // const handleSave = () => {
  //   // Handle save logic (send image and text to API or store in state)
  //   console.log('Saved:', { image, text });
  //   setShowPopup(false);
  // };


  const handleExport = () => {
    if (!data || data.length === 0) {
      alert('No data available to export.');
      return;
    }

    // Format data for export with proper column headers
    const exportData = data.map((item, index) => ({
      "S.No": index + 1,
      "Category": item.category || '',

    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Dish Data');

    XLSX.writeFile(workbook, 'dish-data-export.xlsx');
  };



  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
      console.log("Selected file:", e.target.files[0]);
    }
  };

  const handleFileImport = async (e) => {
    const file = e.target.files[0];
    if (!file) return alert("Please choose a file.");

    const reader = new FileReader();
    reader.onload = async (event) => {
      try {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        const formatted = jsonData.map(row => ({
          dishName: row.dishName || '',
          parentId: Number(row.parentId) || 0,
          dishId: Number(row.dishId) || 0,
        }));

        const response = await axios.post(
          'http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/dishes?vendorId',
          formatted,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        console.log('Import successful:', response.data);
        alert('Categories imported successfully!');
        window.location.reload(); // 🔄 Reload the page after success

      } catch (error) {
        console.error('Import failed:', error);
        alert('Failed to import categories.');
      }
    };

    reader.readAsArrayBuffer(file);
  };



  const handleEdit = async (id) => {
    try {
      setDishId(id);

      const token = localStorage.getItem("authToken"); // ✅ Get token from localStorage
      if (!token) {
        alert("Authentication token missing. Please log in again.");
        return;
      }

      const response = await axios.get(
        `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/grocery/dishes/${id}`,
        {
          headers: {
            "Authorization": `Bearer ${token}`, // ✅ Send token in headers
            "Content-Type": "application/json",
          },
        }
      );

      const dish = response.data;
      // console.log('Fetched Dish:', dish);

      // Set editItem including dishId
      setEditItem({
        dishId: dish.dishId,
        dishName: dish.dishName || '',
        image: dish.dishImage || '',
      });

      setShowEditModal(true);
    } catch (error) {
      alert('Error fetching dish details:\n' + (error.response?.data?.message || error.message));
    }
  };




  const submitEdit = async () => {
    if (!editItem.dishId) {
      alert("Dish ID is missing!");
      return;
    }

    const token = localStorage.getItem("authToken"); // ✅ Get token
    if (!token) {
      alert("Authentication token missing. Please log in again.");
      return;
    }

    try {
      const url = `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/dishes/${editItem.dishId}`;

      const payload = {
        dishName: editItem.dishName,
        image: editItem.image, // base64 string
      };

      const response = await axios.put(url, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`, // ✅ Token in header
        },
      });

      console.log('Edit successful:', response.data);
      alert('Category updated successfully!');
      window.location.reload();
      setShowEditModal(false);
    } catch (error) {
      console.error('Edit failed:', error.response ? error.response.data : error.message);
      alert("Failed to update dish");
    }
  };








  const handleEditImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setEditItem((prev) => ({
          ...prev,
          image: reader.result.split(',')[1], // remove `data:image/...;base64,`
        }));
      };
      reader.readAsDataURL(file);
    }
  };






  const fetchData = async () => {
    const vendorId = localStorage.getItem("vendorId");
    const token = localStorage.getItem("authToken"); // ✅ Get the token

    if (!vendorId) {
      console.warn("⚠️ vendorId not found in localStorage");
      setError(new Error("vendorId missing"));
      setLoading(false);
      return;
    }

    if (!token) {
      console.warn("⚠️ authToken not found in localStorage");
      setError(new Error("authToken missing"));
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(
        `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/grocery/dishes/${vendorId}`,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}` // ✅ Include token
          }
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const dishData = await response.json();

      const parentCategories = dishData.filter(item => item.parentId === 0 || item.parentId === null);

      const formattedData = parentCategories.map(category => {
        const subcategories = dishData.filter(sub => sub.parentId === category.dishId);

        return {
          dishId: category.dishId,
          SNo: category.dishId,
          category: category.dishName,
          image: category.dishImage || '',
          isChecked: false,
          parentId: category.parentId,
          id: category.dishId,
          isAdded: true,
          subcategories: subcategories.map(sub => ({
            dishId: sub.dishId,
            subName: sub.subName || sub.dishName,
            price: sub.price,
            description: sub.description || "",
            image: sub.dishImage,
            menuStatus: sub.menuStatus || "Enable",
            tag: sub.tag || "Veg",
            stockQuantity: sub.stockQuantity || 0,
            gst: sub.gst || 0,
            packingCharges: sub.packingCharges || 0,
            consumedQuantity: sub.consumedQuantity || 0,
            balanceQuantity: sub.balanceQuantity || 0,
            chefType: sub.chefType || 0,
          }))
        };
      });

      // console.log("Formatted Dish Data:", formattedData);
      // localStorage.setItem("formattedDishData", JSON.stringify(formattedData));

      setData(formattedData);
      applyFilter(formattedData, isVegSelected);

    } catch (error) {
      // console.error("Error fetching data:", error);
      setError(error);
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    fetchData();
  }, []);

  const handleCheckboxChange = (e, index) => {
    const { checked } = e.target;
    setData(prevData => {
      const updatedData = [...prevData];
      updatedData[index].isChecked = checked;
      return updatedData;
    });
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setData(prevData =>
      prevData.map(item => ({
        ...item,
        isChecked: isChecked,
      }))
    );
  };

  const handleSave = async () => {
    if (!text.trim() || !image) {
      alert('Please provide both the dish name and image.');
      return;
    }

    const base64Image = image.replace(/^data:image\/\w+;base64,/, '');

    const vendorId = localStorage.getItem("vendorId");
    const token = localStorage.getItem("authToken"); // ✅ Get the token

    if (!vendorId) {
      alert("Vendor ID not found. Please log in again.");
      return;
    }

    if (!token) {
      alert("Authentication token missing. Please log in again.");
      return;
    }

    const payload = {
      dishId: 0,
      price: 0,
      dishName: text.trim(),
      parentId: 0,
      dishImage: base64Image,
      stockQuantity: 0,
      gst: 0,
      packingCharges: 0,
    };

    try {
      const response = await axios.post(
        `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/dishes?vendorId${vendorId}`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` // ✅ Add token to Authorization header
          },
        }
      );

      alert('Item added successfully!');
      setShowPopup(false);
    } catch (error) {
      console.error("Upload failed:", error.response?.data || error.message);
      alert('Failed to add item: ' + (error.response?.data?.message || 'Unknown error'));
    }
  };




  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result); // this will include "data:image/...;base64,..."
      };
      reader.readAsDataURL(file);
    }
  };

  const handleToggleStatus = async (index, subIndex, dishId, currentStatus) => {
    console.log('Clicked Toggle', { index, subIndex, dishId, currentStatus });

    const vendorId = localStorage.getItem("vendorId");
    const authToken = localStorage.getItem("authToken");

    if (!vendorId || !authToken) {
      alert("Authentication failed. Please login again.");
      return;
    }

    const currentBool = currentStatus === "Enable";
    const newBool = !currentBool;
    const newStatus = newBool ? "Enable" : "Disable";

    console.log('Toggling to newStatus:', newStatus);

    // Optimistic UI update
    setData((prevData) => {
      const updatedData = [...prevData];

      if (subIndex === null || subIndex === undefined) {
        updatedData[index] = {
          ...updatedData[index],
          menuStatus: newStatus,
        };
      } else {
        updatedData[index].subcategories[subIndex] = {
          ...updatedData[index].subcategories[subIndex],
          menuStatus: newStatus,
        };
      }

      return updatedData;
    });

    try {
      const url = `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/dishes/${dishId}`;
      const payload = { menuStatus: newStatus };

      const response = await axios.put(url, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`, // ✅ Add this line
        },
      });

      console.log('Backend response:', response.data);

      localStorage.setItem(`menuStatus-${dishId}`, newStatus);

    } catch (error) {
      console.error('Failed to toggle menu visibility:', error);
      alert('Failed to update menu visibility.');

      // Rollback UI
      setData((prevData) => {
        const updatedData = [...prevData];

        if (subIndex === null || subIndex === undefined) {
          updatedData[index].menuStatus = currentStatus;
        } else {
          updatedData[index].subcategories[subIndex].menuStatus = currentStatus;
        }

        return updatedData;
      });
    }
  };


  const handleToggleSubcategoryStock = (dishId, subIndex, parentIndex) => {
    setData(prevData => {
      const newData = [...prevData];
      const sub = newData[parentIndex].subcategories[subIndex];

      sub.stock = (sub.stock === 'In Stock') ? 'Out of Stock' : 'In Stock';

      return newData;
    });
  };





  const handleDeleteRow = async (index, dishId) => {
    if (!window.confirm("Are you sure you want to delete this dish?")) return;

    const token = localStorage.getItem("authToken");

    try {
      const response = await fetch(
        `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/dishes/${dishId}`,
        {
          method: "DELETE",
          headers: {
            "Authorization": `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        alert("Dish deleted successfully!");
        const newData = data.filter(item => item.SNo !== dishId);
        setData(newData);
      } else {
        const result = await response.json();
        alert(`Failed to delete dish. Error: ${result.message || "Unknown error"}`);
      }
    } catch (error) {
      alert("An error occurred while deleting.");
      console.error(error);
    }
  };

  const handleDeleteSubcategory = async (subDishId, subIndex, parentIndex) => {
    if (!window.confirm("Are you sure you want to delete this subcategory?")) return;

    const token = localStorage.getItem("authToken");

    try {
      const response = await fetch(
        `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/dishes/${subDishId}`,
        {
          method: "DELETE",
          headers: {
            "Authorization": `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        alert("Subcategory deleted successfully!");

        setData(prevData => {
          const newData = [...prevData];
          const updatedSubcategories = [...newData[parentIndex].subcategories];
          updatedSubcategories.splice(subIndex, 1);
          newData[parentIndex] = {
            ...newData[parentIndex],
            subcategories: updatedSubcategories,
          };
          return newData;
        });
      } else {
        const result = await response.json();
        alert(`Failed to delete subcategory. Error: ${result.message || "Unknown error"}`);
      }
    } catch (error) {
      alert("An error occurred while deleting the subcategory.");
      console.error(error);
    }
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    setData(prevData => {
      const updatedData = [...prevData];
      updatedData[index][name] = value;
      return updatedData;
    });
  };

  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setImage(URL.createObjectURL(file));
  //   }
  // };
  const handleAddRow = () => {
    const newRow = {
      SNo: (data.length + 1).toString(),
      category: '',
      name: '',
      image: '',
      type: '',
      price: '',
      stock: '',
      isChecked: false,
    };
    setData([...data, newRow]);
  };


  const modalStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '10px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    zIndex: 1000,
    width: '400px', // Define a fixed width for better control over layout
  };

  const inputContainerStyle = {
    marginBottom: '15px',
  };

  const inputFieldStyle = {
    width: '100%',
    padding: '8px',
    fontSize: '14px',
    borderRadius: '5px',
    border: '1px solid #ddd',
  };

  const fileInputStyle = {
    padding: '8px',
    fontSize: '14px',
    borderRadius: '5px',
    border: '1px solid #ddd',
    display: 'block',
    width: '100%',
    marginTop: '10px',
  };

  const imagePreviewStyle = {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100px',
    height: '100px',
    margin: '10px 0',
    borderRadius: '10px',
    border: '1px solid #ccc',
    overflow: 'hidden',
  };

  const imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  };

  // const fileInputStyle = {
  //   display: 'block',
  //   marginTop: '10px',
  // };

  const buttonContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
    textAlign: "center"
  };
  const closeButtonStyle = {
    position: 'absolute',
    top: '10px',
    right: '10px',
    cursor: 'pointer',
  };

  const closeIconStyle = {
    fontSize: '24px',
    fontWeight: 'bold',
    marginBottom: '30px',
    color: '#888',
  };

  const buttonStyle = {
    // padding: '10px 20px',
    height: "32px",
    backgroundColor: '#b15cd6',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: "bold",
    marginTop: "10px"
  };

  const cancelButtonStyle = {
    padding: '10px 20px',
    backgroundColor: '#f44336',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '14px',
  };

  const styles = {
    overlay: {
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1000,
    },
    popup: {
      background: '#fff',
      padding: '20px',
      borderRadius: '8px',
      width: '300px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
      textAlign: 'center',
    },
    image: {
      width: '100%',
      marginTop: '10px',
      borderRadius: '5px',
    },
    input: {
      marginTop: '10px',
      padding: '8px',
      width: '100%',
      borderRadius: '5px',
      border: '1px solid #ccc',
    },
    buttons: {
      marginTop: '15px',
      display: 'flex',
      justifyContent: 'center'
    },
    saveBtn: {
      padding: '8px 12px',
      backgroundColor: '#4CAF50',
      color: 'white',
      border: 'none',
      borderRadius: '5px',
    },
    cancelBtn: {
      padding: '8px 12px',
      backgroundColor: '#f44336',
      color: 'white',
      border: 'none',
      borderRadius: '5px',
    }
  };



  return (
    <div style={{ marginTop: "-60px" }}>
      <div style={{ position: 'relative', top: '-11px', }} className='standard-menu'>
        <style>
          {`
               .custom-switch {
            position: relative;
            display: inline-block;
            width: 100px;
            height: 35px;
            margin-top:11px;
          }

          .custom-switch input {
            opacity: 0;
            width: 0;
            height: 0;
          }

          .custom-slider {
            position: absolute;
            cursor: pointer;
            transition: 0.4s;
            margin-left:-315px;
            font-weight: bold;
            font-size: 14px;
            color: #000;
            text-align: center;
            line-height: 35px;
            width: 100px;
            height: 40px;
            border-radius:5px;
            background-color: rgb(217, 217, 217);
          }

   .custom-slider::before {
  content: "";
  position: absolute;
  height: 16px;
  width: 16px;
  left: 3px;
  top: 10px;
  background-color: #000; /* default */
  transition: 0.4s;
  border-radius: 50%;
}

.custom-slider.veg::before {
  background-color: green;
}

.custom-slider.non-veg::before {
  background-color: red;
}
        `}
        </style>
        {/* <label className="custom-switch">
                    <input
                        type="checkbox"
                        checked={isVegSelected}
                        onChange={() => handleFilterClick(isVegSelected ? 'Non-Veg' : 'Veg')}
                    />
                    <span className={`custom-slider ${isVegSelected ? 'veg' : 'non-veg'}`}>
                        {isVegSelected ? 'Veg' : 'Non-Veg'}
                    </span>

                </label> */}


      </div>

      <br></br>
      <div style={{ display: 'flex', justifyContent: 'end', marginBottom: '5px' }}>

        {showPopup && (
          <div style={styles.overlay}>
            <div style={styles.popup}>

              {/* Close icon */}
              <div
                style={{
                  position: 'absolute',
                  fontSize: '20px',
                  cursor: 'pointer',
                  color: '#888',
                  fontWeight: 'bold',
                  marginLeft: "243px",
                  marginTop: "-18px"
                }}
                onClick={() => setShowPopup(false)}
              >
                ×
              </div>

              <h3>Add Item</h3>

              {/* Square-shaped box for image upload */}
              <div
                style={{
                  width: '141px',
                  height: '123px',
                  border: '2px dashed #aaa',
                  borderRadius: '8px',
                  margin: '10px auto',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  backgroundColor: '#f9f9f9',
                  overflow: 'hidden',
                }}
                onClick={() => document.getElementById('hiddenFileInput').click()}
              >
                {image ? (
                  <img
                    src={image}
                    alt="Preview"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                ) : (
                  <div
                    style={{
                      fontSize: '40px',
                      color: '#bbb',
                      fontWeight: 'bold',
                    }}
                  >
                    +
                  </div>
                )}
              </div>

              <input
                id="hiddenFileInput"
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                style={{ display: 'none' }}
              />

              <input
                type="text"
                placeholder="Enter Category"
                value={text}
                onChange={(e) => setText(e.target.value)}
                style={styles.input}
              />

              <div style={styles.buttons}>
                <button onClick={handleSave} style={styles.saveBtn}>Save</button>
              </div>
            </div>
          </div>
        )}


        <div className='importexportaddbutton' style={{ display: "flex", gap: "10px", marginTop: "-70px", padding: "10px,20px" }}>

          <input
            type="file"
            accept=".xlsx, .xls"
            ref={fileInputRef}
            onChange={handleFileImport}
            style={{ display: 'none' }}
          />

          <button
            style={importExportButton}
            onClick={() => fileInputRef.current.click()}
          >
            Import
          </button>



          <button style={importExportButton} onClick={handleExport}>Export</button>
          <button style={importExportButton}

            onClick={() => setShowPopup(true)}
          >
            Add+
          </button>



        </div>

      </div>


      <div style={{
        overflowX: "auto",   // horizontal scroll visible
        // overflowY: "hidden", // hide vertical scrollbar
        // height: "510px",
        // marginTop: "-5px"
      }} className='standard-table-data' >

        {loading ? (
          <p>Loading data...</p>
        ) : error ? (
          <p style={{ color: 'red' }}>Error fetching data: {error.message}</p>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: "0px", minWidth: "1200px" }}>
            <thead>
              <tr style={{ backgroundColor: '#f2f2f2' }}>
                <th style={tableHeaderStyle}><input type="checkbox" onChange={handleSelectAll} /></th>
                <th style={tableHeaderStyle}>SNo</th>
                <th style={tableHeaderStyle}>Category</th>
                <th style={tableHeaderStyle}>Image</th>
                <th style={tableHeaderStyle}>Price</th>
                <th style={tableHeaderStyle}>Quantity</th>
                {/* <th style={tableHeaderStyle}>Consumed</th>
                <th style={tableHeaderStyle}>Balance</th> */}
                <th
                  style={{
                    ...tableHeaderStyle,
                    textAlign: "center",
                    padding: "8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "6px",
                    }}
                  >
                    {/* Column title */}
                    {/* <div style={{ fontSize: "12px" }}>Type</div> */}

                    {/* Toggle Switch with Text Inside */}
                    <div
                      onClick={() => {
                        // If nothing is selected yet, make Veg the default on first click
                        if (isVegSelected === null) {
                          handleFilterClick("Veg");
                        } else {
                          handleFilterClick(isVegSelected ? "Non-Veg" : "Veg");
                        }
                      }}
                      style={{
                        width: "70px",
                        height: "22px",
                        borderRadius: "20px",
                        backgroundColor:
                          isVegSelected === null
                            ? "#888" // neutral gray before selection
                            : isVegSelected
                              ? "green"
                              : "red",
                        display: "flex",
                        alignItems: "center",
                        justifyContent:
                          isVegSelected === null
                            ? "center"
                            : isVegSelected
                              ? "flex-start"
                              : "flex-end",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        position: "relative",
                        color: "white",
                        fontSize: "11px",
                        fontWeight: "bold",
                        padding: "0 6px",
                      }}
                    >
                      {/* Sliding circle */}
                      {isVegSelected !== null && (
                        <div
                          style={{
                            width: "13px",
                            height: "13px",
                            borderRadius: "50%",
                            backgroundColor: "#fff",
                            position: "absolute",
                            left: isVegSelected ? "3px" : "calc(100% - 14px)",
                            top: "4px",
                            transition: "all 0.3s ease",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                          }}
                        />
                      )}
                      {/* Text inside toggle */}
                      <span
                        style={{ width: "100%", textAlign: "center", zIndex: 1, fontSize: "10px" }}
                      >
                        {isVegSelected === null
                          ? "Type"
                          : isVegSelected
                            ? "Veg"
                            : "Non-Veg"}
                      </span>
                    </div>
                  </div>
                </th>




                {/* <th style={tableHeaderStyle}>ChefType</th> */}
                <th style={tableHeaderStyle}>Description</th>
                <th style={tableHeaderStyle}>gst</th>
                <th style={tableHeaderStyle}>packing</th>
                <th style={tableHeaderStyle}>ItemStatus</th>
                <th style={tableHeaderStyle}>Actions</th>
                {/* Add header for subcategory stock status */}

              </tr>
            </thead>
            <tbody>
              {filteredData.map((item, index) => (

                <React.Fragment key={index}>
                  <tr style={index % 2 === 0 ? evenRowStyle : oddRowStyle}>
                    <td style={tableCellStyle}>
                      <input
                        type="checkbox"
                        checked={item.isChecked || false}
                        onChange={(e) => handleCheckboxChange(e, index)}
                      />
                    </td>
                    <td style={tableCellStyle}>{index + 1}</td>
                    <td style={tableCellStyle}>
                      <div>

                        <input
                          type="text"
                          name="category"
                          value={item.category}
                          onChange={(e) => handleInputChange(e, index)}
                          style={inputStyle}
                        />
                      </div>
                    </td>
                    <td style={tableCellStyle}>
                      <label htmlFor={`fileInput-${index}`} style={{ cursor: 'pointer' }}>
                        <img
                          src={item.image ? `data:image/png;base64,${item.image}` : 'https://via.placeholder.com/47x38?text=No+Image'}
                          alt="Dish"
                          style={{ width: '38px', height: '30px', borderRadius: '10px', marginTop: '-21px' }}
                        />
                      </label>
                      <input
                        id={`fileInput-${index}`}
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleImageChange(e, index)}
                        style={{ display: 'none' }}
                      />
                    </td>
                    <td style={tableCellStyle}> {/* Price column for parent */}
                      {item.price ? `₹${item.price}` : '-'}
                    </td>
                    <td style={tableCellStyle}> {/* Price column for parent */}
                      {item.price ? `₹${item.price}` : '-'}
                    </td>
                    <td style={tableCellStyle}> {item.price ? `₹${item.price}` : '-'}</td>
                    <td style={tableCellStyle}> {/* Price column for parent */}
                      {item.stockQuantity ? `₹${item.stockQuantity}` : '-'}
                    </td>
                    <td style={tableCellStyle}> {/* Price column for parent   */}
                      {item.consumedQuantity ? `₹${item.consumedQuantity}` : '-'}
                    </td>
                    <td style={tableCellStyle}> {/* Price column for parent */}
                      {item.balanceQuantity ? `₹${item.balanceQuantity}` : '-'}
                    </td>
                    <td style={tableCellStyle}> {/* Price column for parent */}
                      {item.tag
                        ? `₹${item.tag
                        }` : '-'}
                    </td>
                    {/* <td style={tableCellStyle}>
                      {item.balanceQuantity ? `₹${item.chefType}` : '-'}
                    </td> */}
                    {/* <td style={tableCellStyle}>
                      {item.gst ? `₹${item.gst}` : '-'}
                    </td> */}
                    {/* <td style={tableCellStyle}>
                      {item.packingCharges ? `₹${item.packingCharges}` : '-'}
                    </td> */}
                    <td style={tableCellStyle}>
                      <button
                        style={{
                          backgroundColor: '#00b894',
                          color: 'white',
                          borderRadius: '4px',
                          padding: '4px 8px',
                          border: 'none',
                          cursor: 'pointer',
                          width: 'fit-content'
                        }}
                        onClick={() => handleAddSubCategory(item.dishId)}
                      >
                        Add
                      </button>
                      <button
                        style={addButtonStyle}
                        onClick={() => item.isAdded ? handleEdit(item.SNo) : handleSave(item, index)}
                      >
                        {item.isAdded ? <FaEdit /> : <FaSave />}
                      </button>
                      <button
                        style={deleteButtonStyle}
                        onClick={() => handleDeleteRow(index, item.SNo, item.parentId)}
                      >
                        <FaTrash />
                      </button>
                    </td>
                    {/* Empty cell for stock status on parent row */}

                  </tr>

                  {/* Subcategories */}
                  {item.subcategories && item.subcategories.length > 0 && item.subcategories.map((sub, subIndex) => (
                    <tr key={`sub-${sub.dishId}`} style={{ backgroundColor: '#f9f9f9' }}>
                      <td style={tableCellStyle}> {/* Price column for parent */}
                        {item.price ? `₹${item.price}` : ''}
                      </td>
                      <td style={tableCellStyle}> {/* Price column for parent */}
                        {item.price ? `₹${item.price}` : ''}
                      </td>
                      <td style={tableCellStyle}>↳ {sub.subName}</td>
                      <td style={tableCellStyle}>
                        <img
                          src={sub.image ? `data:image/png;base64,${sub.image}` : 'https://via.placeholder.com/47x38?text=No+Image'}
                          alt="Sub Dish"
                          style={{ width: '38px', height: '30px', borderRadius: '10px' }}
                        />
                      </td>
                      <td style={tableCellStyle}>₹{sub.price}</td>

                      <td style={tableCellStyle}>{sub.stockQuantity}</td>
                      {/* <td style={tableCellStyle}>{sub.consumedQuantity}</td>
                      <td style={tableCellStyle}>{sub.balanceQuantity}</td> */}
                      {/* <td style={tableCellStyle}>{sub.balanceQuantity}</td> */}
                      <td style={tableCellStyle}>
                        {sub.tag === "Veg" ? (
                          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                            <div
                              style={{
                                width: "16px",
                                height: "16px",
                                border: "2px solid green",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "2px",
                              }}
                            >
                              <div
                                style={{
                                  width: "8px",
                                  height: "8px",
                                  backgroundColor: "green",
                                  borderRadius: "50%",
                                }}
                              ></div>
                            </div>
                            <span style={{ color: "green", fontWeight: "500" }}>Veg</span>
                          </div>
                        ) : sub.tag === "Non_Veg" ? (
                          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                            <div
                              style={{
                                width: "16px",
                                height: "16px",
                                border: "2px solid red",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "2px",
                              }}
                            >
                              <div
                                style={{
                                  width: "8px",
                                  height: "8px",
                                  backgroundColor: "red",
                                  borderRadius: "50%",
                                }}
                              ></div>
                            </div>
                            <span style={{ color: "red", fontWeight: "500" }}>Non-Veg</span>
                          </div>
                        ) : (
                          sub.tag
                        )}
                      </td>



                      {/* <td style={tableCellStyle}>
                        {sub.chefType}
                      </td> */}
                      <td style={tableCellStyle}>{sub.description}</td>
                      <td style={tableCellStyle}>
                        {sub.gst}
                      </td>
                      <td style={tableCellStyle}>
                        {sub.packingCharges}
                      </td>
                      <td style={tableCellStyle}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                          <label className="switch">
                            <input
                              type="checkbox"
                              // Convert string "Enable"/"Disable" to boolean
                              checked={sub.menuStatus === "Disable"}
                              onChange={() => handleToggleStatus(index, subIndex, sub.dishId, sub.menuStatus)}

                            />
                            <span className="slider round"></span>
                          </label>
                          <span
                            style={{
                              marginTop: '4px',
                              color: 'black',
                              fontSize: '12px',
                              cursor: 'pointer',
                            }}
                          >
                            {sub.menuStatus === "Disable" ? 'Hide' : 'Show'}
                          </span>

                        </div>
                      </td>

                      <td style={tableCellStyle}>
                        <div style={{ marginLeft: "40px" }}>
                          <button
                            style={addButtonStyle}
                            onClick={() => handleEditSubcategory(sub.dishId, subIndex, index)}
                          >
                            <FaEdit />
                          </button>
                          <button
                            style={deleteButtonStyle}
                            onClick={() => handleDeleteSubcategory(sub.dishId, subIndex, index)}
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                      {/* New Item Status toggle */}

                    </tr>
                  ))}

                </React.Fragment>
              ))}
            </tbody>
          </table>


        )}
      </div>

      {showEditModal && editItem && (
        <div style={modalStyle}>
          <div style={closeButtonStyle} onClick={() => setShowEditModal(false)}>
            <span style={closeIconStyle}>×</span> {/* Close icon */}
          </div>
          <br></br>
          {/* <h3 style={{ justifyContent: "center", textAlign: "center", fontWeight: "bold" }}>Edit Dish</h3> */}

          <div style={inputContainerStyle}>

            <input
              id="dishName"
              type="text"
              value={editItem.dishName}
              onChange={(e) => setEditItem({ ...editItem, dishName: e.target.value })}
              style={inputFieldStyle}
            />
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '20px 0' }}>
            <div style={imagePreviewStyle}>
              <label htmlFor="dishImage" style={{ cursor: 'pointer' }}>
                <img
                  src={
                    editItem.image
                      ? `data:image/png;base64,${editItem.image}`
                      : 'https://via.placeholder.com/100x100'
                  }
                  alt="Preview"
                  style={imageStyle}
                />
              </label>
              <input
                id="dishImage"
                type="file"
                accept="image/*"
                onChange={(e) => handleEditImageChange(e)}
                style={{ display: 'none' }}
              />
            </div>
          </div>



          <div style={buttonContainerStyle}>
            <button onClick={submitEdit} style={buttonStyle}>Update</button>
          </div>
        </div>
      )}



      {showSubcategoryPopup && (
        <div
          style={{
            position: 'fixed',
            top: 63,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.6)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
            padding: '20px',
            boxSizing: 'border-box',
          }}
        >
          <div
            style={{
              height: "77vh",
              overflow: "auto",
              position: 'relative',  // needed for close icon positioning
              backgroundColor: '#fff',
              padding: '30px 25px',
              borderRadius: '12px',
              width: '400px',
              maxWidth: '95%',
              boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
              display: 'flex',
              flexDirection: 'column',
              gap: '15px',
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            }}
          >
            {/* Close Icon */}
            <div
              onClick={() => setShowSubcategoryPopup(false)}
              style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                fontSize: '22px',
                fontWeight: '700',
                color: '#999',
                cursor: 'pointer',
                userSelect: 'none',
                transition: 'color 0.3s',
              }}
              onMouseEnter={e => (e.currentTarget.style.color = '#00b894')}
              onMouseLeave={e => (e.currentTarget.style.color = '#999')}
              aria-label="Close popup"
              title="Close"
            >
              &times;
            </div>

            <h3 style={{ margin: 0, fontWeight: '600', fontSize: '1.3rem', color: '#333' }}>
              Add Subcategory for: <span style={{ color: '#00b894' }}>{parentDishDetails?.dishName}</span>
            </h3>

            <input
              type="text"
              value={subDishName}
              onChange={(e) => setSubDishName(e.target.value)}
              placeholder="Subcategory Dish Name"
              style={{
                padding: '10px 12px',
                fontSize: '1rem',
                borderRadius: '6px',
                border: '1.8px solid #ccc',
                outline: 'none',
                transition: 'border-color 0.3s',
              }}
              onFocus={e => e.target.style.borderColor = '#00b894'}
              onBlur={e => e.target.style.borderColor = '#ccc'}
            />

            <input
              type="number"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              placeholder="Price"
              style={{
                padding: '10px 12px',
                fontSize: '1rem',
                borderRadius: '6px',
                border: '1.8px solid #ccc',
                outline: 'none',
                transition: 'border-color 0.3s',
              }}
              onFocus={e => e.target.style.borderColor = '#00b894'}
              onBlur={e => e.target.style.borderColor = '#ccc'}
            />
            <input
              type="number"
              value={stockQuantity}
              onChange={(e) => setStockQuantity(e.target.value)}
              placeholder="Quantity"
              style={{
                padding: '10px 12px',
                fontSize: '1rem',
                borderRadius: '6px',
                border: '1.8px solid #ccc',
                outline: 'none',
                transition: 'border-color 0.3s',
              }}
              onFocus={e => e.target.style.borderColor = '#00b894'}
              onBlur={e => e.target.style.borderColor = '#ccc'}
            />

            <input
              type="number"
              value={gst}
              onChange={(e) => setGst(e.target.value)}
              placeholder="gst"
              style={{
                padding: '10px 12px',
                fontSize: '1rem',
                borderRadius: '6px',
                border: '1.8px solid #ccc',
                outline: 'none',
                transition: 'border-color 0.3s',
              }}
              onFocus={e => e.target.style.borderColor = '#00b894'}
              onBlur={e => e.target.style.borderColor = '#ccc'}
            />
            <input
              type="number"
              value={discount}
              onChange={(e) => setdiscount(e.target.value)}
              placeholder="discount"
              style={{
                padding: '10px 12px',
                fontSize: '1rem',
                borderRadius: '6px',
                border: '1.8px solid #ccc',
                outline: 'none',
                transition: 'border-color 0.3s',
              }}
              onFocus={e => e.target.style.borderColor = '#00b894'}
              onBlur={e => e.target.style.borderColor = '#ccc'}
            />

            <input
              type="number"
              value={packingCharges}
              onChange={(e) => setPackingCharges(e.target.value)}
              placeholder="packingcharges"
              style={{
                padding: '10px 12px',
                fontSize: '1rem',
                borderRadius: '6px',
                border: '1.8px solid #ccc',
                outline: 'none',
                transition: 'border-color 0.3s',
              }}
              onFocus={e => e.target.style.borderColor = '#00b894'}
              onBlur={e => e.target.style.borderColor = '#ccc'}
            />



            <select
              value={tag}
              onChange={(e) => setTag(e.target.value)}
              style={{
                padding: '10px 12px',
                fontSize: '1rem',
                borderRadius: '6px',
                border: '1.8px solid #ccc',
                outline: 'none',
                transition: 'border-color 0.3s',
                backgroundColor: '#fff',
                cursor: 'pointer',
              }}
              onFocus={e => e.target.style.borderColor = '#00b894'}
              onBlur={e => e.target.style.borderColor = '#ccc'}
            >
              <option value="Veg">Veg</option>
              <option value="Non_Veg">Non Veg</option>
            </select>

            <select
              value={stock}
              onChange={(e) => setStock(e.target.value)}
              style={{
                padding: '10px 12px',
                fontSize: '1rem',
                borderRadius: '6px',
                border: '1.8px solid #ccc',
                outline: 'none',
                transition: 'border-color 0.3s',
                backgroundColor: '#fff',
                cursor: 'pointer',
              }}
              onFocus={e => e.target.style.borderColor = '#00b894'}
              onBlur={e => e.target.style.borderColor = '#ccc'}
            >
              <option value="In_Stock">In Stock</option>
              <option value="Out_of_Stock">Out of Stock</option>
            </select>
            <input
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Description"
              style={{
                padding: '10px 12px',
                fontSize: '1rem',
                borderRadius: '6px',
                border: '1.8px solid #ccc',
                outline: 'none',
                transition: 'border-color 0.3s',
              }}
              onFocus={e => e.target.style.borderColor = '#00b894'}
              onBlur={e => e.target.style.borderColor = '#ccc'}
            />

            <select
              value={chefType}
              onChange={(e) => setChefType(e.target.value)} style={{
                padding: '10px 12px',
                fontSize: '1rem',
                borderRadius: '6px',
                border: '1.8px solid #ccc',
                outline: 'none',
                transition: 'border-color 0.3s',
                backgroundColor: '#fff',
                cursor: 'pointer',
              }} >
              {/* <option value="Chef_All">Chef All</option> */}
              <option value="Chef_North">Chef North</option>
              <option value="Chef_South">Chef South</option>
              <option value="Chef_Chinese">Chef Chinese</option>
              <option value="Chef_Continental">Chef Continental</option>
            </select>




            <div
              style={{
                width: '100%',
                maxWidth: '175px',             // optional
                minHeight: '138px',
                // height: '180px',               // increased height
                border: '2px dashed #bbb',
                borderRadius: '10px',
                margin: '15px auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                backgroundColor: '#fafafa',
                overflow: 'visible',           // ✅ changed from 'hidden' to 'visible'
                transition: 'border-color 0.3s',
              }}
              onClick={() => document.getElementById('hiddenFileInput').click()}
              onMouseEnter={e => (e.currentTarget.style.borderColor = '#00b894')}
              onMouseLeave={e => (e.currentTarget.style.borderColor = '#bbb')}
            >
              {image ? (
                <img
                  src={image}
                  alt="Preview"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',       // ✅ changed to 'contain' to avoid distortion/cutoff
                    borderRadius: '10px',
                  }}
                />
              ) : (
                <div
                  style={{
                    fontSize: '50px',
                    color: '#ccc',
                    fontWeight: 'bold',
                    userSelect: 'none',
                  }}
                >
                  +
                </div>
              )}
            </div>

            <input
              id="hiddenFileInput"
              type="file"
              accept="image/*"
              onChange={handleSubImageChange}
              style={{ display: 'none' }}
            />

            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '10px',
              }}
            >
              <button
                onClick={handleSubcategorySubmit}
                style={{
                  backgroundColor: '#00b894',
                  color: 'white',
                  padding: '10px 20px',
                  border: 'none',
                  borderRadius: '6px',
                  fontWeight: '600',
                  fontSize: '1rem',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s',
                }}
                onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#019973')}
                onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#00b894')}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}


      {showSubEditModal && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            {/* Close Icon */}
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button
                onClick={() => setShowSubEditModal(false)}
                style={{
                  background: 'transparent',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer',
                  color: '#888',
                }}
              >
                &times;
              </button>
            </div>

            {/* <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Edit Subcategory</h2> */}

            {/* Dish Name */}
            <div style={{ marginBottom: '15px' }}>
              {/* <label style={{ fontWeight: '500', display: 'block', marginBottom: '6px' }}>
                Dish Name:
              </label> */}
              <input
                type="text"
                value={editSubItem.subName}
                onChange={(e) => setEditSubItem((prev) => ({ ...prev, subName: e.target.value }))}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '6px',
                  border: '1px solid #ccc',
                  fontSize: '14px',
                }}
              />
            </div>

            {/* Price */}
            <div style={{ marginBottom: '15px' }}>
              {/* <label style={{ fontWeight: '500', display: 'block', marginBottom: '6px' }}>
                Price:
              </label> */}
              <input
                type="number"
                value={editSubItem.price}
                onChange={(e) => setEditSubItem((prev) => ({ ...prev, price: e.target.value }))}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '6px',
                  border: '1px solid #ccc',
                  fontSize: '14px',
                }}
              />
            </div>

            <div style={{ marginBottom: '15px' }}>
              {/* <label style={{ fontWeight: '500', display: 'block', marginBottom: '6px' }}>
                                     Price:
                                          </label> */}
              <input
                type="number"
                value={editSubItem.stockQuantity}
                onChange={(e) => setEditSubItem((prev) => ({ ...prev, stockQuantity: e.target.value }))}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '6px',
                  border: '1px solid #ccc',
                  fontSize: '14px',
                }}
              />
            </div>
            <div style={{ marginBottom: '15px' }}>
              {/* <label style={{ fontWeight: '500', display: 'block', marginBottom: '6px' }}>
                                     Price:
                                          </label> */}
              <input
                type="text"
                value={editSubItem.chefType}
                onChange={(e) => setEditSubItem((prev) => ({ ...prev, chefType: e.target.value }))}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '6px',
                  border: '1px solid #ccc',
                  fontSize: '14px',
                }}
              />
            </div>
            {/* Image Preview and Upload */}
            <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
              <div style={imagePreviewStyle}>
                <label htmlFor="subDishImage" style={{ cursor: 'pointer' }}>
                  <img
                    src={
                      editSubItem.image
                        ? editSubItem.image.startsWith('data:image')
                          ? editSubItem.image
                          : `data:image/png;base64,${editSubItem.image}`
                        : 'https://via.placeholder.com/100x100'
                    }
                    alt="Preview"
                    style={{
                      width: '100px',
                      height: '100px',
                      objectFit: 'cover',
                      borderRadius: '10px',
                      border: '1px solid #ccc',
                    }}
                  />
                </label>
                <input
                  id="subDishImage"
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      const reader = new FileReader();
                      reader.onloadend = () => {
                        setEditSubItem((prev) => ({
                          ...prev,
                          image: reader.result.split(',')[1],
                        }));
                      };
                      reader.readAsDataURL(file);
                    }
                  }}
                  style={{ display: 'none' }}
                />
              </div>
            </div>

            {/* Save Button */}
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <button onClick={submitEditSubcategory} style={submitButtonStyle}>
                update
              </button>
            </div>
          </div>
        </div>
      )}






    </div>
  );
};

const modalOverlayStyle = {
  position: 'fixed',
  top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const modalContentStyle = {
  backgroundColor: 'white',
  borderRadius: '8px',
  padding: '20px',
  width: '320px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
};

const cancelButtonStyle = {
  backgroundColor: '#ccc',
  border: 'none',
  padding: '8px 16px',
  borderRadius: '4px',
  cursor: 'pointer',
};

const submitButtonStyle = {
  backgroundColor: '#00b894',
  color: 'white',
  border: 'none',
  padding: '8px 16px',
  borderRadius: '4px',
  cursor: 'pointer',
};


const buttonStyle = {
  backgroundColor: '#b15cd6',
  color: 'white',
  border: 'none',
  cursor: 'pointer',
  borderRadius: '5px',
  width: '100px',
  fontWeight: "bold"
};

const tableHeaderStyle = {
  border: '1px solid #ddd',
  textAlign: 'center',
  fontWeight: 'bold',
  backgroundColor: '#b15cd6',
  color: 'white',
};

const tableCellStyle = {
  border: '1px solid #ddd',
  textAlign: 'center',
};

const evenRowStyle = { backgroundColor: '#fff' };
const oddRowStyle = { backgroundColor: '#fff' };

const inputStyle = {
  // width: '100%',
  border: 'none',
  backgroundColor: 'transparent',
  textAlign: 'center',
};

const addButtonStyle = {
  backgroundColor: '#fff',
  color: 'green',
  border: 'none',
  cursor: 'pointer',
  borderRadius: '5px',
  marginRight: '10px',
  fontSize: "20px"
};

const deleteButtonStyle = {
  backgroundColor: '#fff',
  color: 'red',
  border: 'none',
  cursor: 'pointer',
  borderRadius: '5px',
  fontSize: "20px"
};

const importExportButton = {
  height: '35px',
  marginTop: "20px",
  borderRadius: "4px",
  border: "none",
  backgroundColor: "#b15cd6",
  color: "white",
  fontWeight: 'bold',
};

export default Grocerybasicmenu ;
